import { useUserStore } from "@/store/user";
import { useFeatureStore } from "@/store/feature";
import { useLayoutStore } from "@/store/layout";
import authMiddleware from "@/router/middleware/authMiddleware.ts";
import popupMiddleware from "@/router/middleware/popupMiddleware.ts";
import freeVideoMiddleware from "@/router/middleware/freeVideoMiddleware.ts";
import unsubscribeMailsMiddleware from "@/router/middleware/unsubscribeMailsMiddleware.ts";
import trackMiddleware from "@/router/middleware/trackMiddleware.ts";
import customPageMiddleware from "@/router/middleware/customPageMiddleware.ts";
import playerMiddleware from "@/router/middleware/playerMiddleware.ts";
import metaMiddleware from "@/router/middleware/metaMiddleware.ts";
import landingMiddleware from "@/router/middleware/landingMiddleware.ts";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";
import lawLimitationMiddleware from "@/router/middleware/lawLimitationMiddleware.ts";
import camerasMiddleware from "@/router/middleware/camerasMiddleware.ts";

export default [
  ({ to }: MiddlewareInterface) => {
    document.title = typeof to.meta.title === "function" ? to.meta.title() : "Ersties";
  },
  trackMiddleware,
  ...authMiddleware,
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    if (to.matched.some((record) => record.meta.requiresPremium) && !useUserStore(pinia).isPremium) {
      await redirect({
        path: useFeatureStore(pinia).getLandingUrl,
        query: { redirect: to.fullPath },
      });
    }
  },
  async ({ from, to, redirect, pinia }: MiddlewareInterface) => {
    if (!useUserStore(pinia).isLoggedIn) {
      return true;
    }

    if (to.path === "/") {
      const redirectUrl = useFeatureStore(pinia).getLandingUrl;

      await redirect({ path: redirectUrl, query: to.query });

      if (from.path === redirectUrl) {
        await useLayoutStore(pinia).setGlobalLoading(false);
      }
    }
  },
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    if (!useFeatureStore(pinia).hasAgeVerificationFeature) {
      return;
    }

    const path = to.path.replace(/\/+$/, "");

    if (path === "/blog" || path === "/lecker_blog") {
      await redirect({ path: "/" });
    }
  },
  popupMiddleware,
  lawLimitationMiddleware,
  freeVideoMiddleware,
  camerasMiddleware,
  unsubscribeMailsMiddleware,
  landingMiddleware,
  customPageMiddleware,
  playerMiddleware,
  metaMiddleware,
];
